export default __webpack_public_path__ + "fb6eb69bd9c59255c84b6a28a5f9275b.wav";